import { StyleSheet } from "@react-pdf/renderer"
import { colors } from "../styles"

export const styles = StyleSheet.create({
  table: {
    flexDirection: "column",
    width: "100%",
    height: "auto",
    borderRadius: 4,
    border: `1px solid ${colors.gray["20"]}`,
    borderRight: "none",
    marginBottom: 8,
  },
  tableRow: {
    textAlign: "center",
    display: "flex",
    flexDirection: "row",
    borderRadius: 4,
    width: "100%",
    minHeight: 20,
    flexShrink: 1,
  },
  columnRun: {
    width: "8%",
    maxWidth: 45,
    flexGrow: 1,
  },
  columnLevel: {
    width: "10%",
    flexGrow: 1,
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  columnWestigard: {
    width: "15%",
    flexGrow: 1,
  },
  columnStatus: {
    width: "10%",
    maxWidth: 60,
    flexGrow: 1,
  },
  columnObservation: {
    width: "34%",
    flexGrow: 1,
  },
  tableCell: {
    fontSize: 6,
    lineHeight: 1,
    fontWeight: 700,
    color: colors.gray[8],
    textAlign: "left",
  },
  tableCellInfo: {
    fontSize: 7.5,
    lineHeight: 1.25,
    fontWeight: 600,
    color: `${colors.gray[8]}`,
    textAlign: "left",
  },
  tableCellInfoItalic: {
    fontSize: 7,
    lineHeight: 1.25,
    fontWeight: 400,
    fontStyle: "italic",
    color: `${colors.gray[8]}`,
    marginTop: 2,
  },
  cBachText: {
    fontSize: 6,
    lineHeight: 1,
    fontWeight: 600,
    fontStyle: "italic",
    color: `${colors.gray[8]}`,
  },
  runCardDataLabel: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: 2,
    flexGrow: 1,
    padding: "6pt 8pt",
    width: "100%",
    textAlign: "left",
    borderBottom: `1px solid ${colors.gray["20"]}`,
    borderRight: `1px solid ${colors.gray["20"]}`,
    backgroundColor: colors.gray[10],
  },
  runCardDataValue: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    textAlign: "left",
    padding: "6pt 8pt",
    borderRight: `1px solid ${colors.gray["20"]}`,
  },
  launchValue: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    padding: "6pt 8pt",
    border: "none",
    flexGrow: 1,
    width: "100%",
  },
  tableCellVerticalLine: {
    flexGrow: 1,
    minHeight: 20,
    maxWidth: 1,
    minWidth: 1,
    alignSelf: "center",
    backgroundColor: `${colors.gray["20"]}`,
  },
  containerObservation: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    padding: "6pt 8pt",
    flexGrow: 1,
    border: `1px solid ${colors.gray["20"]}`,
    borderLeft: "none",
    borderBottom: "none",
    gap: 4,
  },
  observation: {
    color: `${colors.gray[30]}`,
    textAlign: "left",
    fontSize: 7,
    lineHeight: 1.5,
    fontWeight: 600,
  },
  westgardRulesContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    flexGrow: 1,
    gap: 4,
    padding: "6pt 4pt",
    borderRight: `1px solid ${colors.gray["20"]}`,
  },
  westgardRulePill: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "3pt 4pt",
    borderRadius: "50%",
  },
  westgardRulePillText: {
    fontSize: 7.5,
    fontWeight: 700,
  },
})
